import {
  baseVendorApiSettingsDefaults,
  defaultHttpAgentSettings,
  defaultRateLimitationSettings,
  defaultVendorApiHttpAdvancedSettings,
} from './base';
import type { VersaApiSettingsDefaults } from './types';

export const versaDefaults: VersaApiSettingsDefaults = {
  ...baseVendorApiSettingsDefaults,
  ...defaultHttpAgentSettings,
  ...defaultRateLimitationSettings,
  ...defaultVendorApiHttpAdvancedSettings,
  // Not documented but Versa support give us advise 600 Rest API calls in a window of 30 seconds.
  // We don't know exact recovery strategy, but Mira tried refill bucket by 10 requests and it works for 5K requests
  maxConcurrentRequests: 10,
  maxCapacity: 100,
  refillRate: 2,
  paginationLimit: 1000,
  combinedDiscovery: false,
};
